import { datadogRum } from '@datadog/browser-rum';

export const navigateToUrl = (url: string, context?: string): void => {
  datadogRum.addAction('navigate', { url, context });
  window.location.href = url;
};
